/**
 * Maps objects with an enabled boolean key value from an array to a new array
 * @example
 * let arr = [{ enabled: true, key: 'example-one' }, { enabled: false, key: 'example-two' }];
 * mapEnabledToKey(arr, keyName, propName)
 * @param {Array} arr - The array of objects to filter and map
 *   @param {Object} arr.obj - An object containing an item to be filtered
 *     @param {Boolean} arr.obj.enabled - Enabled boolean
 *     @param {string} arr.obj.key - key to be used in the returned array
 * @param {String} keyName - The name of the key to map to. Defaults to slug
 * @param {String} propName - The name of the prop to map. Defaults to slug
 * @returns {Array} new mapped array containing objects of key key:values
 */
export function mapEnabledToKey (arr, keyName = 'slug', propName = 'slug') {
  return arr
    .filter(item => item.enabled)
    .map(item => ({ [keyName]: item[propName] }));
}


// WEBPACK FOOTER //
// ./resources/assets/js/app/store/services/mapEnabledToKey.js